import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
}
export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonical,
  ogImage = 'https://www.bkcustoms.nl/og-image.jpg',
  ogType = 'website'
}) => {
  const fullCanonical = canonical ? `https://www.bkcustoms.nl${canonical}` : undefined;
  return <Helmet data-id="element-474">
      <title data-id="element-475">{title}</title>
      <meta name="description" content={description} data-id="element-476" />
      {fullCanonical && <link rel="canonical" href={fullCanonical} data-id="element-477" />}
      {/* Open Graph tags */}
      <meta property="og:title" content={title} data-id="element-478" />
      <meta property="og:description" content={description} data-id="element-479" />
      <meta property="og:type" content={ogType} data-id="element-480" />
      {fullCanonical && <meta property="og:url" content={fullCanonical} data-id="element-481" />}
      <meta property="og:image" content={ogImage} data-id="element-482" />
      <meta property="og:site_name" content="BKCustoms" data-id="element-483" />
      <meta property="og:locale" content="nl_NL" data-id="element-484" />
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-485" />
      <meta name="twitter:title" content={title} data-id="element-486" />
      <meta name="twitter:description" content={description} data-id="element-487" />
      <meta name="twitter:image" content={ogImage} data-id="element-488" />
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" data-id="element-489" />
      <meta name="language" content="Dutch" data-id="element-490" />
      <meta name="author" content="BKCustoms" data-id="element-491" />
    </Helmet>;
};